import React, { useEffect, useRef, useState } from "react";
import Webcam from "react-webcam";
import "../styles/style.css";
import {getVideoKyc,videoVeify} from "../redux/actions/document";
import Loader from "../components/Loader";
const options = {
  maxSizeMB: 2,
  maxWidthOrHeight: 1920,
  useWebWorker: true,
};

const videoConstraints = {
  width: 250,
  height: 250,
  borderRadius: "50%",
  // padding: "px 0",
  overflow: "hidden",
  position: "absolute",
  top: "50%",
  left: 0,
  right: 0,
  transform: "translateY(-50%)",
  margin: "0 auto",
  boxShadow: "0 0 0 9px #fff, 0 0 0 12px #ffc022, 0 0px 0px 0px rgb(0 0 0)",
};

const imageView = {
  width: "100%",
  height: "100%",
  objectFit: "cover",
  // borderRadius:hp("20%"),
  // borderRadius: "50%",
};

const uploadSelfie = {
  width: 250,
  height: 250,
  borderRadius: "50%",
  // padding: "px 0",
  overflow: "hidden",
  position: "absolute",
  top: "50%",
  left: 0,
  right: 0,
  transform: "translateY(-50%)",
  margin: "0 auto",
  boxShadow: "0 0 0 9px #fff, 0 0 0 12px #16C96F, 0 0px 0px 0px rgb(0 0 0)",
};

const uploadPic = {
  width: "100%",
  height: "100%",
  objectFit: "cover",
};
var atob = require("atob");
const VideoKyc = (props) => {
  //const [params, setParams] = us
  const webcamRef = React.useRef(null);
  const mediaRecorderRef = React.useRef(null);
  const [capturing, setCapturing] = React.useState(false);
  const [recordedChunks, setRecordedChunks] = React.useState([]);
  const [challangeData, setChallangeData] = React.useState({});
  const [timer, setTimer] = React.useState(0);
  const [timerInterval, setTimerInterval] = React.useState(null);
  const [loader, setLoader] = React.useState(false);
  const[id, setId] = React.useState('');

  const userId = new URLSearchParams(window.location.search).get("userId");

  const handleVerify = () => {
    // Get the latest data from the ref
    const { recordedChunks: chunks, id: currentId } = latestDataRef.current;
    
    if (!currentId || chunks.length === 0) {
      setLoader(false);
      alert('Verification failed: Missing data. Please try again.');
      return;
    }
    
    const blob = new Blob(chunks, {
      type: "video/webm"
    });
    
    // Create FormData and append the blob and challenge_id
    const formData = new FormData();
    formData.append('challenge_id', currentId);
    formData.append('video', blob, 'video.webm'); // Add filename for the blob
    setLoader(true)
    // Make the API call
    videoVeify(formData)
        .then((res) => {
          setLoader(false)
          // Handle successful verification
          if (res?.data?.is_live) {
            // You can add success handling here
            alert('Video verification successful');
            window.location.reload();
          }else{
            alert('Video verification failed');
            window.location.reload();
          }
        })
        .catch((err) => {
          setLoader(false)
          // Handle error appropriately
        });
    };

  const handleDataAvailable = React.useCallback(
    ({ data }) => {
      if (data.size > 0) {
        setRecordedChunks((prev) => {
          return prev.concat(data);
        });
      }
    },
    [setRecordedChunks]
  );

  // Create a ref to store the latest chunks and id
  const latestDataRef = React.useRef({
    recordedChunks: [],
    id: ''
  });

  // Update the ref whenever recordedChunks or id changes
  React.useEffect(() => {
    latestDataRef.current.recordedChunks = recordedChunks;
  }, [recordedChunks]);

  React.useEffect(() => {
    latestDataRef.current.id = id;
  }, [id]);

  const stopRecordingAndCleanup = React.useCallback(() => {
    if (mediaRecorderRef.current && mediaRecorderRef.current.state === 'recording') {
      // Request final data chunk before stopping
      mediaRecorderRef.current.requestData();
      
      // Set up one-time stop handler before stopping
      mediaRecorderRef.current.addEventListener('stop', () => {
        // Wait longer for chunks to be processed
        setTimeout(() => {
          handleVerify();
        }, 1000); // Increased timeout to 1000ms
      }, { once: true });

      mediaRecorderRef.current.stop();
      setCapturing(false);
      if (timerInterval) {
        clearInterval(timerInterval);
        setTimerInterval(null);
      }
    }
  }, [timerInterval]);

  const setupRecording = React.useCallback(() => {
    mediaRecorderRef.current = new MediaRecorder(webcamRef.current.stream, {
      mimeType: "video/webm"
    });

    // Set up data handler
    mediaRecorderRef.current.addEventListener("dataavailable", handleDataAvailable);

    return mediaRecorderRef.current;
  }, [handleDataAvailable]);

  const handleSubmit = () => {
    setLoader(true);
    getVideoKyc(userId).then((res) => {
        setChallangeData(res?.data);
        setId(res?.data?.challenge_id);
        setLoader(false)
    })
        .catch((err) => {
            handleError(err);
            setLoader(false)
        });
  };

  const handleStartCaptureClick = React.useCallback(() => {
    // Check if we have an ID before starting capture
    if (!latestDataRef.current.id) {
      // Try to fetch the data again
      handleSubmit();
      // Show alert to user
      alert('Please wait a moment while we prepare the verification. Try again in a few seconds.');
      return;
    }
    
    setCapturing(true);
    setTimer(0);
    setRecordedChunks([]);

    try {
      if (!webcamRef.current || !webcamRef.current.stream) {
        alert('Camera access is required. Please allow camera access and try again.');
        return;
      }
      
      const recorder = setupRecording();
      recorder.start();
      recorder.requestData(); // Request initial chunk

      // Update timer and stop after 5 seconds
      const interval = setInterval(() => {
        setTimer(prevTimer => {
          const newTimer = prevTimer + 1;
          if (newTimer >= 6) {
            clearInterval(interval);
            stopRecordingAndCleanup();
            return 6;
          }
          return newTimer;
        });
      }, 1000);
      setTimerInterval(interval);
    } catch (error) {
      setCapturing(false);
      alert('Failed to start recording. Please try again.');
    }
  }, [webcamRef, setCapturing, mediaRecorderRef, stopRecordingAndCleanup]);

  const handleStopCaptureClick = React.useCallback(() => {
    stopRecordingAndCleanup();
  }, [stopRecordingAndCleanup]);

  const handleDownload = React.useCallback(() => {
    if (recordedChunks.length) {
      const blob = new Blob(recordedChunks, {
        type: "video/webm"
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";
      a.href = url;
      a.download = "react-webcam-stream-capture.webm";
      a.click();
      window.URL.revokeObjectURL(url);
      setRecordedChunks([]);
    }
  }, [recordedChunks]);

  useEffect(() => {
    handleSubmit();
  }, []);

 
  return (
    <div style={{ textAlign: "center" }}>
      {loader &&   <div className="react_loading">
          <Loader />
          </div>}
      <h2 style={{margin:"10px"}}>Steps for kyc verification</h2>
        {
        challangeData?.challenge_sequence?.map((item, index) => {
            return (
                <div key={index}>
                  step{index+1}
                    <h4>{item}</h4>
                   
                </div>
            )
        })
    }
        <>
      <div style={{
        position: 'relative',
        width: '640px',
        height: '480px',
        margin: '0 auto',
        border: '3px solid #ffc022',
        borderRadius: '8px',
        overflow: 'hidden'
      }}>
        <Webcam 
          audio={false} 
          ref={webcamRef}
          width={640}
          height={480}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover'
          }}
        />
      {capturing && (
        <div style={{ 
          position: 'absolute', 
          bottom: '20px', 
          right: '20px', 
          backgroundColor: 'rgba(0, 0, 0, 0.7)', 
          color: 'white', 
          padding: '8px 12px', 
          borderRadius: '4px',
          fontSize: '16px',
          fontWeight: 'bold',
          zIndex: 1000,
          boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
        }}>
          {Math.floor(timer / 60)}:{(timer % 60).toString().padStart(2, '0')}
        </div>
      )}
      </div>
      {capturing ? (
        <div className="text-center pt-5">
        <button
          type="text"
          onClick={handleStopCaptureClick}
          className="btn bg-orange btnContinue text-white rounded-lg px-5 py-3 mb-3"
        >
         Stop Capture
        </button>
      </div>
        // <button onClick={handleStopCaptureClick}>Stop Capture</button>
      ) : (
        <div className="text-center pt-5">
        <button
          type="text"
          onClick={handleStartCaptureClick}
          className="btn bg-orange btnContinue text-white rounded-lg px-5 py-3 mb-3"
        >
          Start Capture
        </button>
      </div>
        // <button onClick={handleStartCaptureClick}>Start Capture</button>
      )}
      {recordedChunks.length > 0 && (
         <div className="text-center pt-5">
         <button
           type="text"
           onClick={handleDownload}
           className="btn bg-orange btnContinue text-white rounded-lg px-5 py-3 mb-3"
         >
           Download
         </button>
       </div>
        // <button onClick={handleDownload}>Download</button>
      )}
    
    </>

<div>
  {
    recordedChunks.length > 0 && (
      <div className="text-center pt-5">
            <button
              type="text"
              onClick={handleVerify}
              className="btn bg-orange btnContinue text-white rounded-lg px-5 py-3 mb-3"
            >
              Verifiy
            </button>
          </div>

    )
  }

</div>
      
    </div>
  );
};

export default VideoKyc;
